import React, {useContext} from 'react';
import SidebarNavigationButton from "../../../components/SidebarNavigationButton/SidebarNavigationButton";
import {useTranslation} from "react-i18next";
import {isMobile} from "react-device-detect";
import {SidebarContext} from "../../../Sidebar";
import { getUserRole } from '../../../../../../helpers/user';
import { UserRole } from '../../../../../../app/enums/UserRole';
import { useAppSelector } from '../../../../../../app/store';
import { selectCurrentUser } from '../../../../../../features/authentication/authenticationSliceSelectors';

type SidebarMenuDashboardProps = {
    expandedId: string;
    onClick?: (id: string) => void;
};

const SidebarMenuDashboard: React.FC<SidebarMenuDashboardProps> = ({
                                                                       expandedId,
                                                                       onClick: onClickProp,
                                                                   }) => {
    const {t} = useTranslation();

    const {
        expanded,
        hoverExpanded,
        setIsExpandedOnHover
    } = useContext(SidebarContext);

    const handleNavigationClick = (id: string) => {
        if (onClickProp) {
            onClickProp(id);
        }

        if (isMobile && !expanded && hoverExpanded) {
            setIsExpandedOnHover(false);
        }
    };

    const user = useAppSelector(selectCurrentUser);

    if (user){
        
        let role = getUserRole(user);

        if (role === UserRole.Client) {
            return null;
        }
    }

    return (
        <SidebarNavigationButton id={'sidebar-dashboard-item'} expandedId={expandedId}
                                 type={'primary'}
                                 onClick={handleNavigationClick}
                                 text={t("sidebar.dashboard")}
                                 title={t("sidebar.dashboard")}
                                 path={'/'}
                                 icon={"faDashboard"}/>
    );
};

export default SidebarMenuDashboard;
